<template>
  <div class="input-amount">
    <span
      class="d-no-lg-bl"
      :class="{ disabled: modelValue < 1 }"
      @click="$emit('decrease')"
      >-</span
    >
    <input type="text" ref="textInput" :value="modelValue" @change="onChange" />
    <span class="d-no-lg-bl" @click="$emit('increase')">+</span>

    <InputAmountButtons v-on="$listeners" :disabled="modelValue < 1" />
  </div>
</template>

<script>
import InputAmountButtons from './InputAmountButtons';

export default {
  name: 'InputAmount',
  components: {
    InputAmountButtons,
  },
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    modelValue: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 99,
    },
  },
  methods: {
    onChange(event) {
      const value = parseInt(event.target.value);

      if (isNaN(value)) {
        this.$refs.textInput.value = this.modelValue;
        return;
      }

      if (value < this.min || value === '') {
        this.$refs.textInput.value = this.min;
        return;
      }

      if (value > this.max) {
        this.$refs.textInput.value = this.max;
        return;
      }

      this.$emit('change', parseInt(value));
    },
  },
};
</script>
